import { render, staticRenderFns } from "./VContract.vue?vue&type=template&id=327d95b3&"
import script from "./VContract.vue?vue&type=script&lang=js&"
export * from "./VContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports